import React from "react";
import { Radio } from "@opendate-app/setlist";

const accent = (selected) => (selected ? "var(--sl-bg-brand-solid)" : "var(--sl-border-primary)");

const styles = {
  card: (selected, disabled) => ({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    overflow: "hidden",
    borderRadius: "var(--radius-xl)",
    border: selected ? "1px solid var(--sl-bg-brand-solid)" : "1px solid var(--sl-border-secondary)",
    boxShadow: selected ? "0 0 0 1px var(--sl-bg-brand-solid)" : "none",
    transition: "box-shadow .15s, border-color .15s",
    background: "var(--sl-bg-primary)",
    cursor: disabled ? "not-allowed" : "pointer",
  }),
  panel: (selected) => ({
    height: 96,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: selected ? "var(--sl-bg-brand-primary)" : "var(--sl-bg-secondary)",
    transition: "background .15s",
  }),
  body: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    padding: "12px 14px 14px",
    borderTop: "1px solid var(--sl-border-secondary)",
  },
  text: { flex: 1, minWidth: 0 },
  label: (disabled) => ({
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "20px",
    color: disabled ? "var(--sl-text-disabled)" : "var(--sl-text-primary)",
  }),
  description: (disabled) => ({
    fontSize: 12,
    lineHeight: "18px",
    color: disabled ? "var(--sl-text-disabled)" : "var(--sl-text-tertiary)",
  }),
  radio: { marginTop: 2 },
  bar: (width, height, background, radius = 3) => ({ width, height, borderRadius: radius, background }),
};

export const EmailIllustration = ({ selected }) => (
  <div data-illustration="email" style={{ alignSelf: "stretch", width: "100%", display: "flex", padding: "14px 20px 0" }}>
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        gap: 6,
        padding: 10,
        background: "var(--sl-bg-primary)",
        border: "1px solid var(--sl-border-secondary)",
        borderBottom: "none",
        borderRadius: "6px 6px 0 0",
      }}
    >
      <div style={styles.bar("100%", 14, accent(selected))} />
      <div style={styles.bar("80%", 5, "var(--sl-border-secondary)")} />
      <div style={styles.bar("60%", 5, "var(--sl-border-secondary)")} />
      <div style={{ ...styles.bar(36, 10, accent(selected)), marginTop: 2 }} />
    </div>
  </div>
);

export const SmsIllustration = ({ selected }) => (
  <div data-illustration="sms" style={{ width: "100%", display: "flex", flexDirection: "column", gap: 6, padding: "0 20px" }}>
    <div
      style={{
        alignSelf: "flex-start",
        maxWidth: "70%",
        display: "flex",
        flexDirection: "column",
        gap: 4,
        padding: "6px 10px",
        background: "var(--sl-bg-primary)",
        border: "1px solid var(--sl-border-secondary)",
        borderRadius: "12px 12px 12px 4px",
      }}
    >
      <div style={styles.bar(72, 5, "var(--sl-border-primary)")} />
      <div style={styles.bar(48, 5, "var(--sl-border-primary)")} />
    </div>
    <div
      style={{
        alignSelf: "flex-end",
        padding: "6px 10px",
        background: accent(selected),
        borderRadius: "12px 12px 4px 12px",
      }}
    >
      <div style={{ ...styles.bar(56, 5, "var(--sl-bg-primary)"), opacity: 0.7 }} />
    </div>
  </div>
);

export const PushIllustration = ({ selected }) => (
  <div
    data-illustration="push"
    style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", gap: 6, padding: "0 16px" }}
  >
    <div style={{ fontSize: 18, fontWeight: 600, lineHeight: "20px", color: "var(--sl-text-quaternary)" }}>9:41</div>
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: 8,
        background: "var(--sl-bg-primary)",
        border: "1px solid var(--sl-border-secondary)",
        borderRadius: 10,
      }}
    >
      <div style={{ ...styles.bar(18, 18, accent(selected), 5), flexShrink: 0 }} />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 4 }}>
        <div style={styles.bar("60%", 5, "var(--sl-text-disabled)")} />
        <div style={styles.bar("85%", 5, "var(--sl-border-secondary)")} />
      </div>
    </div>
  </div>
);

const BroadcastTypeCard = ({ value, label, description, Illustration, selected, disabled, onSelect }) => (
  <label style={styles.card(selected, disabled)}>
    <div style={styles.panel(selected)} aria-hidden="true">
      <Illustration selected={selected} />
    </div>
    <div style={styles.body}>
      <div style={styles.text}>
        <div style={styles.label(disabled)}>{label}</div>
        <div style={styles.description(disabled)}>{description}</div>
      </div>
      <span style={styles.radio}>
        <Radio
          name="broadcast-type"
          value={value}
          checked={selected}
          disabled={disabled}
          aria-label={label}
          onChange={() => { if (!disabled) onSelect(value); }}
        />
      </span>
    </div>
  </label>
);

export default BroadcastTypeCard;
